import { AppProduct } from '@matematykagryzie/models';

import { Period } from '../period';
import { AppProductId } from './app-product-id';
import { ProductPlatform } from './product-platform';
import { ProductType } from './product-type';

export const firstConsumable: AppProduct = {
  productId: AppProductId.Comsumable2021_08_31,
  platform: ProductPlatform.App,
  type: ProductType.OneTimePurchase,

  period: null,
  expiresAt: '2021-08-31T00:00:00.000Z',
  amount: 49.99,
  regularAmount: null,
  currency: 'PLN',
  name: 'Miesięczny dostęp do kursu maturalnego z matematyki.',
  description:
    'Naucz się powtarzalnych zadań na maturze i zdobądź wymarzone 30%',
};

export const m1: AppProduct = {
  productId: AppProductId.SubscriptionM1,
  platform: ProductPlatform.App,
  type: ProductType.AutoRenewableSubscription,
  period: Period.M1,
  amount: 3999,
  regularAmount: null,
  currency: 'PLN',
  name: 'Miesięczny dostęp do kursu maturalnego z matematyki.',
  description:
    'Naucz się powtarzalnych zadań na maturze i zdobądź wymarzone 30%',
};

export const m3: AppProduct = {
  productId: AppProductId.SubscriptionM3,
  platform: ProductPlatform.App,
  type: ProductType.AutoRenewableSubscription,
  period: Period.M3,
  amount: 9999,
  regularAmount: 39.99 * 3,
  currency: 'PLN',
  name: 'Trzy miesięczny dostęp do aplikacji matematyka gryzie.',
  description:
    'Naucz się powtarzalnych zadań na maturze i zdobądź wymarzone 30%',
};

export const m6: AppProduct = {
  productId: AppProductId.SubscriptionM6,
  platform: ProductPlatform.App,
  type: ProductType.AutoRenewableSubscription,
  period: Period.M6,
  amount: 159.99,
  regularAmount: 39.99 * 6,
  currency: 'PLN',
  name: 'Połroczny dostęp do aplikacji matematyka gryzie.',
  description:
    'Naucz się powtarzalnych zadań na maturze i zdobądź wymarzone 30%',
};

export const m12: AppProduct = {
  productId: AppProductId.SubscriptionM12,
  platform: ProductPlatform.App,
  type: ProductType.AutoRenewableSubscription,
  period: Period.M12,
  amount: 229.99,
  regularAmount: 39.99 * 12,
  currency: 'PLN',
  name: 'Roczny dostęp do aplikacji matematyka gryzie.',
  description:
    'Naucz się powtarzalnych zadań na maturze i zdobądź wymarzone 30%',
};

export const appProducts = [m1, m3, m6, m12];
